import {Component} from 'react'
import {Badge} from 'reactstrap'
import PropTypes from 'prop-types'

export default class StateLabel extends Component {
  static propTypes = {
    filled: PropTypes.bool.isRequired,
    locked: PropTypes.bool.isRequired,
    published: PropTypes.bool.isRequired,
  }

  static defaultProps = {
    filled: false,
    locked: false,
    published: true,
  }

  render() {
    const {filled, locked, published} = this.props

    return <>
      {filled ? <Badge color="dark">Pourvue</Badge> : ''}
      {locked ? <Badge color="warning">Verrouillée</Badge> : ''}
      {published ? '' : <Badge color="warning">Non publiée</Badge>}
    </>
  }
}
